export async function preloadFont(source: File | string, name: string): Promise<FontFace> {
    // @ts-ignore because FontFace is experimental or whatever
    if (!FontFace) {
        return Promise.reject()
    }

    // @ts-ignore because FontFace is experimental or whatever
    const url = typeof source === 'string' ? source : URL.createObjectURL(source)
    const fontFace = new FontFace(name, `url(${url})`)
    ;(document as any).fonts.add(fontFace)
    return fontFace.load()
}

export async function preloadImage(source: File | string): Promise<HTMLImageElement> {
    const url = typeof source === 'string' ? source : URL.createObjectURL(source)

    return new Promise((resolve, reject) => {
        const img = document.createElement('img')
        img.onerror = () => reject()
        img.onload = () => {
            resolve(img)
        }
        img.crossOrigin = 'anonymous'
        img.src = url
    })
}

export async function preloadVideo(source: File | string): Promise<HTMLVideoElement> {
    const url = typeof source === 'string' ? source : URL.createObjectURL(source)

    return new Promise((resolve, reject) => {
        const video = document.createElement('video')
        video.onerror = () => reject()
        video.oncanplay = () => {
            resolve(video)
        }
        video.crossOrigin = 'anonymous'
        video.preload = 'auto'
        video.src = url
    })
}
